import Encoding from 'encoding-japanese'
import dayjs from 'dayjs'
import { getYamatoTimeCode } from './deliveryTimeZones'

// 【B2クラウド】送り状CSVレイアウト（ヘッダ有・97列）
export const YAMATO_CSV_HEADER = [
  'お客様管理番号',                              // 0
  '送り状種類',                                  // 1
  'クール区分',                                  // 2
  '伝票番号',                                    // 3
  '出荷予定日',                                  // 4
  'お届け予定（指定）日',                        // 5
  '配達時間帯',                                  // 6
  'お届け先コード',                              // 7
  'お届け先電話番号',                            // 8
  'お届け先電話番号枝番',                        // 9
  'お届け先郵便番号',                            // 10
  'お届け先住所',                                // 11
  'お届け先住所（アパートマンション名）',        // 12
  'お届け先会社・部門名１',                      // 13
  'お届け先会社・部門名２',                      // 14
  'お届け先名',                                  // 15
  'お届け先名略称カナ',                          // 16
  '敬称',                                        // 17
  'ご依頼主コード',                              // 18
  'ご依頼主電話番号',                            // 19
  'ご依頼主電話番号枝番',                        // 20
  'ご依頼主郵便番号',                            // 21
  'ご依頼主住所',                                // 22
  'ご依頼主住所（アパートマンション名）',        // 23
  'ご依頼主名',                                  // 24
  'ご依頼主略称カナ',                            // 25
  '品名コード１',                                // 26
  '品名１',                                      // 27
  '品名コード２',                                // 28
  '品名２',                                      // 29
  '荷扱い１',                                    // 30
  '荷扱い２',                                    // 31
  '記事',                                        // 32
  'コレクト代金引換額（税込）',                  // 33
  'コレクト内消費税額等',                        // 34
  '営業所止置き',                                // 35
  '営業所コード',                                // 36
  '発行枚数',                                    // 37
  '個数口枠の印字',                              // 38
  'ご請求先顧客コード',                          // 39
  'ご請求先分類コード',                          // 40
  '運賃管理番号',                                // 41
  'クロネコwebコレクトデータ登録',               // 42
  'クロネコwebコレクト加盟店番号',               // 43
  'クロネコwebコレクト申込受付番号１',           // 44
  'クロネコwebコレクト申込受付番号２',           // 45
  'クロネコwebコレクト申込受付番号３',           // 46
  'お届け予定ｅメール利用区分',                  // 47
  'お届け予定ｅメールe-mailアドレス',            // 48
  '入力機種',                                    // 49
  'お届け予定eメールメッセージ',                 // 50
  'お届け完了eメール利用区分',                   // 51
  'お届け完了ｅメールe-mailアドレス',            // 52
  'お届け完了ｅメールメッセージ',                // 53
  'クロネコ収納代行利用区分',                    // 54
  '収納代行決済ＱＲコード印刷',                  // 55
  '収納代行請求金額(税込)',                      // 56
  '収納代行内消費税額等',                        // 57
  '収納代行請求先郵便番号',                      // 58
  '収納代行請求先住所',                          // 59
  '収納代行請求先住所（アパートマンション名）',  // 60
  '収納代行請求先会社・部門名１',                // 61
  '収納代行請求先会社・部門名２',                // 62
  '収納代行請求先名(漢字)',                      // 63
  '収納代行請求先名(カナ)',                      // 64
  '収納代行問合せ先名(漢字)',                    // 65
  '収納代行問合せ先郵便番号',                    // 66
  '収納代行問合せ先住所',                        // 67
  '収納代行問合せ先住所（アパートマンション名）',// 68
  '収納代行問合せ先電話番号',                    // 69
  '収納代行管理番号',                            // 70
  '収納代行品名',                                // 71
  '収納代行備考',                                // 72
  '複数口くくりキー',                            // 73
  '検索キータイトル１',                          // 74
  '検索キー１',                                  // 75
  '検索キータイトル２',                          // 76
  '検索キー２',                                  // 77
  '検索キータイトル３',                          // 78
  '検索キー３',                                  // 79
  '検索キータイトル４',                          // 80
  '検索キー４',                                  // 81
  '検索キータイトル５',                          // 82
  '検索キー５',                                  // 83
  '予備',                                        // 84
  '予備',                                        // 85
  '投函予定メール利用区分',                      // 86
  '投函予定メールe-mailアドレス',                // 87
  '投函予定メールメッセージ',                    // 88
  '投函完了メール（お届け先宛）利用区分',        // 89
  '投函完了メール（お届け先宛）e-mailアドレス',  // 90
  '投函完了メール（お届け先宛）メールメッセージ',// 91
  '投函完了メール（ご依頼主宛）利用区分',        // 92
  '投函完了メール（ご依頼主宛）e-mailアドレス',  // 93
  '投函完了メール（ご依頼主宛）メールメッセージ',// 94
  '連携管理番号',                                // 95
  '通知メールアドレス',                          // 96
]

// 出荷元（ご依頼主）情報
// postalCode は要確認（歌志内市字歌神36）
const ISSUER = {
  name: 'りんどう',
  address: '北海道歌志内市字歌神36',
  phone: '0125359107',
  postalCode: '0680124',
}

// クール区分コード: 1=冷凍（デフォルト）, 2=冷蔵
const COOL_FROZEN = '1'
const COOL_REFRIGERATED = '2'

interface DeliveryRecipientInfo {
  name?: string
  postalCode?: string
  prefecture?: string
  address?: string
  phone?: string
}

interface YamatoCsvProduct {
  storageType?: string
}

export interface YamatoCsvShipment {
  id: string
  customer?: string
  shippingDate?: string
  deliveryTimeZone?: string
  products?: YamatoCsvProduct[]
  deliveryRecipient?: DeliveryRecipientInfo
  itemName2?: string
  itemName3?: string
  itemName4?: string
}

export const buildYamatoB2CsvRow = (shipment: YamatoCsvShipment): string[] => {
  const row = new Array(YAMATO_CSV_HEADER.length).fill('')
  const recipient = shipment.deliveryRecipient

  row[0] = shipment.id || ''                         // お客様管理番号（20文字以内）
  row[1] = '0'                                       // 送り状種類: 0=発払い
  row[3] = ''                                        // 伝票番号: B2クラウドが割り当て

  // クール区分: チルド品が1つでもあれば冷蔵、なければ冷凍
  const products = Array.isArray(shipment.products) ? shipment.products : []
  row[2] = products.some((p) => p.storageType === 'チルド')
    ? COOL_REFRIGERATED
    : COOL_FROZEN

  row[4] = shipment.shippingDate              // 出荷予定日（YYYY/M/DD形式のまま使用）
    ? dayjs(shipment.shippingDate.replace(/\//g, '-')).format('YYYY/M/DD')
    : ''

  row[6] = getYamatoTimeCode(shipment.deliveryTimeZone || '指定なし') // 配達時間帯

  row[8]  = recipient?.phone || ''                   // お届け先電話番号
  row[10] = (recipient?.postalCode || '').replace(/-/g, '') // お届け先郵便番号（ハイフンなし）
  row[11] = `${recipient?.prefecture || ''}${recipient?.address || ''}` // お届け先住所
  row[15] = recipient?.name || shipment.customer || '' // お届け先名
  row[17] = '様'                                     // 敬称

  row[19] = ISSUER.phone                             // ご依頼主電話番号
  row[21] = ISSUER.postalCode                        // ご依頼主郵便番号
  row[22] = ISSUER.address                           // ご依頼主住所
  row[24] = ISSUER.name                              // ご依頼主名

  // 品名: 鹿肉 + itemName2〜4 をスペース区切りで結合
  const extraNames = [shipment.itemName2, shipment.itemName3, shipment.itemName4]
    .filter(Boolean)
    .join(' ')
  row[27] = extraNames ? `鹿肉 ${extraNames}` : '鹿肉'

  row[35] = '0'  // 営業所止置き: 0=なし
  row[37] = '1'  // 発行枚数
  row[38] = '0'  // 個数口枠の印字
  row[40] = '0'  // ご請求先分類コード
  row[41] = '0'  // 運賃管理番号
  row[47] = '0'  // お届け予定eメール利用区分
  row[51] = '0'  // お届け完了eメール利用区分
  row[54] = '0'  // クロネコ収納代行利用区分
  row[86] = '0'  // 投函予定メール利用区分
  row[89] = '0'  // 投函完了メール（お届け先宛）利用区分
  row[92] = '0'  // 投函完了メール（ご依頼主宛）利用区分

  return row
}

const escapeCsvValue = (value: string) => `"${String(value ?? '').replace(/"/g, '""')}"`

// B2クラウド取込用にShift-JISエンコードしたCSVのBlobを生成する
export const generateYamatoB2Csv = (rows: string[][]): Blob => {
  const text = [YAMATO_CSV_HEADER, ...rows]
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\r\n')
  const unicodeArray = Encoding.stringToCode(text)
  const sjisArray = Encoding.convert(unicodeArray, { to: 'SJIS', from: 'UNICODE' })
  return new Blob([new Uint8Array(sjisArray)], { type: 'text/csv' })
}

// B2クラウドから出力された出荷済みCSVの列インデックス
const RESULT_CUSTOMER_MANAGEMENT_NUMBER_COL = 0 // お客様管理番号
const RESULT_TRACKING_NUMBER_COL = 3            // 伝票番号

export interface YamatoShippingRecord {
  trackingNumber: string
  customerManagementNumber: string
}

// CSVの1行をカンマ区切りで分割する（ダブルクォート囲み・エスケープに対応）
const parseCsvLine = (line: string): string[] => {
  const result: string[] = []
  let current = ''
  let inQuotes = false
  for (let i = 0; i < line.length; i++) {
    const char = line[i]
    if (inQuotes) {
      if (char === '"') {
        if (line[i + 1] === '"') {
          current += '"'
          i++
        } else {
          inQuotes = false
        }
      } else {
        current += char
      }
    } else if (char === '"') {
      inQuotes = true
    } else if (char === ',') {
      result.push(current)
      current = ''
    } else {
      current += char
    }
  }
  result.push(current)
  return result
}

// Excelが科学記数法に変換した伝票番号を元の数値文字列に戻す（例: "4.38597E+11" → "438597000000"）
const parseTrackingNumber = (value: string): string => {
  const trimmed = value.trim()
  if (/^[\d.]+[Ee][+-]?\d+$/.test(trimmed)) {
    return String(Math.round(parseFloat(trimmed)))
  }
  return trimmed
}

// Shift-JISエンコードされたB2クラウドの出荷済みCSVファイルをUTF-8文字列に変換する
export const decodeYamatoCsvFile = async (file: File): Promise<string> => {
  const buffer = await file.arrayBuffer()
  const unicodeArray = Encoding.convert(new Uint8Array(buffer), 'UNICODE', 'SJIS')
  return Encoding.codeToString(unicodeArray)
}

// B2クラウドの出荷済みCSV（ヘッダ行あり）から 伝票番号 と お客様管理番号 を取得する
export const parseYamatoShippingResultCsv = (text: string): YamatoShippingRecord[] => {
  const lines = text.split(/\r\n|\r|\n/).filter((line) => line.trim() !== '')
  const records: YamatoShippingRecord[] = []
  // 先頭行はヘッダのためスキップ
  for (let i = 1; i < lines.length; i++) {
    const cols = parseCsvLine(lines[i])
    const rawTracking = cols[RESULT_TRACKING_NUMBER_COL] || ''
    const trackingNumber = parseTrackingNumber(rawTracking)
    const customerManagementNumber = (cols[RESULT_CUSTOMER_MANAGEMENT_NUMBER_COL] || '').trim()
    if (!trackingNumber || !customerManagementNumber) continue
    records.push({ trackingNumber, customerManagementNumber })
  }
  return records
}
